import DOMPurify from 'dompurify'
import { html_beautify as beautify } from 'js-beautify'

export const cleanSanitizeHtml = (html) => beautify(DOMPurify.sanitize(html))
